import type { CustomerOrganizationType } from '@mntn-dev/domain-types'
import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [RegistrationTypes, RegistrationTypeSchema] = EnumBuilder(
  'video-professional',
  'brand'
)
export type RegistrationType = ZodInfer<typeof RegistrationTypeSchema>

export const mapRegistrationTypeToOrganizationType: Record<
  RegistrationType,
  CustomerOrganizationType
> = {
  'video-professional': 'agency',
  brand: 'brand',
}
